import React, { useState, useEffect } from "react";
import { IoIosClose } from "react-icons/io";
// import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { useForm } from "react-hook-form";
// import ReverseService from "../../../services/ReverseService";
import { parseISO, format } from "date-fns";
import CollectOrderService from "../../../services/CollectOrderService";
import MinorCollectOrderDetails from "../../molecules/MinorCollectOrderDetails";
import MovementService from "../../../services/MovementService";



export default function CollectOrderDetailsModal({
  isModalOpen,
  setModalOpen,
  collectOrderId,
}) {
//   const {
//     register,
//     handleSubmit,
//     reset,
//     formState: { errors },
//     setValue,
//   } = useForm();

  const [collectOrderObject, setCollectOrderObject] = useState();
  const [movements, setMovements] = useState([]);

  useEffect(() => {
    async function fetchRequest() {
      const cOrder = await CollectOrderService.getCollectOrdersById(
        collectOrderId
      );
      setCollectOrderObject(cOrder);

      // Buscar movimentações da coleta
      const data = await MovementService.getMovementsFromCollect(collectOrderId);
      setMovements(data?.collectMovements || []);
    }

    fetchRequest();
  }, [isModalOpen, collectOrderId]);

//   const onSubmit = async () => {

//     const data = { status: "ROTA DE COLETA" };

//     try {
//       await CollectOrderService.updateParcial(collectOrderId, data);
//       toast.success("Enviada para expedição!");
//     } catch (error) {
//       toast.error(error.message);
//     }

//     setModalOpen(!isModalOpen);
//     reset();
  
//   };

  const onClose = () => {
    setModalOpen(!isModalOpen);
    // reset();
  };

  if (isModalOpen) {
    return (
      <div
        className="flex flex-col relative z-10"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto"
          onClick={onClose}
        >
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="flex flex-col w-[648px] h-fit pb-4 relative transform rounded-lg bg-white text-left shadow-xl transition-all mt-6" onClick={(e) => e.stopPropagation()}>
              <button
                onClick={onClose}
                className="absolute -top-7 -right-7 rounded-full p-1"
              >
                <div className="w-12 h-12 flex bg-gray-200 justify-center items-center rounded-full ms-6">
                  <div className="flex justify-center items-center">
                    <IoIosClose color={"black"} size={32} />
                  </div>
                </div>
              </button>
              <div className="flex flex-col px-4 text-left gap-2 bg-gray-800 rounded-t-lg">
                <div className="text-white text-xl font-bold mt-4">
                  ORDEM DE COLETA #{" "}
                  {collectOrderObject?.collectOrder.idCollectOrder}
                </div>
                <div className="flex justify-between">
                  {/* <div className="text-white text-sm px-4">
                    Coleta:{" "}
                    {collectOrderObject?.collectOrder.idCollectOrder}
                  </div> */}
                  <div className="text-white text-sm px-4">
                    Ref Solicitação:{" "}
                    {collectOrderObject?.collectOrder.idRequest}
                  </div>
                </div>
              </div>

              {/* Detalhes da coleta */}
              <MinorCollectOrderDetails collectOrder={collectOrderObject?.collectOrder} />

              {/* DIV movimentações */}
              {movements.length !== 0 && (
                <div className="flex flex-col w-full max-h-96 overflow-y-auto px-2 mt-4 text-[11px]">
                  <div className="font-bold ms-2 mb-1">MOVIMENTAÇÕES:</div>
                  <table className="min-w-full bg-white text-[11px]">
                    <thead>
                      <tr className="bg-gray-800 text-white border-b">
                        <th className="px-6 py-1 rounded-tl-lg">Data</th>
                        <th className="px-6 py-1">Usuário</th>
                        <th className="px-6 py-1">Status Anterior</th>
                        <th className="px-6 py-1"></th>
                        <th className="px-6 py-1">Status Novo</th>
                        <th className="px-6 py-1">Obs</th>
                        <th className="px-6 py-1 rounded-tr-lg">Carimbo</th>
                      </tr>
                    </thead>
                    <tbody>
                      {movements?.slice().reverse().map((movement) => (
                        <tr key={movement._id}>
                          <td className="px-1 py-1 whitespace-nowrap border-b">
                            {format(parseISO(movement.createdAt), 'dd/MM/yy HH:mm')}
                          </td>
                          <td className="px-1 py-1 whitespace-nowrap border-b">
                            {movement.user?.userName}
                          </td>
                          <td className="px-1 py-1 border-b">{movement.oldStatus}</td>
                          <td className="px-1 py-1 border-b">{">>"}</td>
                          <td className="px-1 py-1 border-b">{movement.newStatus}</td>
                          <td className="px-1 py-1 border-b text-[10px]">
                            {movement.obsAtualizacao ? movement.obsAtualizacao : '-'}
                          </td>
                          <td className="px-1 py-1 border-b text-[10px]">
                            {movement.carimbo ? movement.carimbo : '-'}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

            </div>
          </div>
        </div>
      </div>
    );
  }
}
